import {Component, OnInit} from '@angular/core';
import {AdminService} from "../service/admin.service";
import {LoadingController, ModalController} from "@ionic/angular";
import {CompaniesDealersPage} from "./companies-dealers/companies-dealers.page";
import {SearchUtil} from "../shared/utils/SearchUtil";

@Component({
  selector: 'app-companies',
  templateUrl: './companies.page.html',
  styleUrls: ['./companies.page.scss'],
})
export class CompaniesPage implements OnInit {
  companies: any;
  companiesFiltered: any;
  loading: HTMLIonLoadingElement;

  constructor(private adminService: AdminService,
              public loadingController: LoadingController,
              public modalController: ModalController
  ) {
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.getAllCompanies();
  }

  getAllCompanies() {
    this.loading.present();
    this.adminService.getAllCompanies().subscribe((res: any) => {
      this.companies = res;
      this.companiesFiltered = res;
      this.loading.dismiss();
    });
  }

  addCompany() {

  }

  deleteProfile(profileId: any) {

  }

  async manageDealers(company: any) {
    const modal = await this.modalController.create({
      component: CompaniesDealersPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        company,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
      }
    });
    return await modal.present();
  }

  onChangePage($event: any) {

  }

  search(event: any) {
    if (event && event.detail && event.detail.value) {
      const result = SearchUtil.findMatchingPositions(this.companies, event.detail.value);
      this.companiesFiltered = result;
    }
    if (event.detail.value === '') {
      this.companiesFiltered = this.companies;
    }
  }
}
